import { render } from "./AccountMenu.vue?vue&type=template&id=5cde53c2&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=5cde53c2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cde53c2"]])

export default __exports__